import { render, staticRenderFns } from "./uploadIndex.vue?vue&type=template&id=a2e99812&scoped=true&"
import script from "./uploadIndex.vue?vue&type=script&lang=js&"
export * from "./uploadIndex.vue?vue&type=script&lang=js&"
import style0 from "./uploadIndex.vue?vue&type=style&index=0&id=a2e99812&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e99812",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2e99812')) {
      api.createRecord('a2e99812', component.options)
    } else {
      api.reload('a2e99812', component.options)
    }
    module.hot.accept("./uploadIndex.vue?vue&type=template&id=a2e99812&scoped=true&", function () {
      api.rerender('a2e99812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/familyMotto/uploadIndex.vue"
export default component.exports